import styles from "./style.less";
import React from "react";
const classnames = require("classnames");

const GraphicCode = (props: any) => {
  const {
    graphicCode,
    inputGraphicCode,
    closeGraphicCodeHandle,
    sendGraphicCodeHandle,
    inputGraphicCodeHandle,
  } = props;

  //解决焦点错位
  const blurHandle = () => {
    setTimeout(() => {
      if (/iPhone/i.test(navigator.userAgent)) {
        window.scrollTo(0, 0);
      }
    }, 100);
  };

  return (
    <div className={classnames(styles.graphicCode)}>
      <header className={classnames(styles.graphicCodeHeader)}>
        <div
          className={classnames(styles.close)}
          onClick={closeGraphicCodeHandle}
        ></div>
        <div className={classnames(styles.title)}>输入图形验证码</div>
      </header>
      <div className={classnames(styles.graphicCodeMain)}>
        <div className={classnames(styles.tips)}>
          登录过于频繁，请先完成以下验证
        </div>

        <div className={styles.graphicCode_box}>
          <div className={classnames(styles.graphicCode_box_input)}>
            <input
              className={styles.input}
              maxLength={4}
              placeholder="请输入验证码"
              type="text"
              onChange={inputGraphicCodeHandle}
              onBlur={blurHandle}
              value={inputGraphicCode}
            />
          </div>
          <div
            className={classnames(styles.graphicCode_box_img)}
            onClick={sendGraphicCodeHandle}
          >
            <div className={classnames(styles.base64Img)}>
              {graphicCode && (
                <img src={`data:image/png;base64,${graphicCode}`} alt="" />
              )}
            </div>
            <div className={classnames(styles.resend)}></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GraphicCode;
